import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/omigeo.css";

const screens = [
  "login-id",
  "login-password",
  "login-passwordless-email-code",
  "email-otp-challenge",
  "passkey-enrollment",
];

function Preview() {
  return (
    <div className="shell">
      <div className="brand">
        <div className="brand-mark" aria-hidden />
        <div className="brand-name">omiGeo ACUL</div>
      </div>
      <div className="card">
        <h1>Universal Login screens</h1>
        <p className="muted">
          Built assets land in <code>dist/assets/&lt;screen&gt;/</code>. Host them
          on <code>acul.omigeo.com</code> and bind via Auth0 CLI / Dashboard.
          Local Auth0-context preview: <code>auth0 acul dev</code>.
        </p>
        <ul className="muted">
          {screens.map((s) => (
            <li key={s}>
              <code>{s}</code>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Preview />
  </StrictMode>,
);
